import React from "react";

const InputRadio = (props) => {
  const {
    label,
    values = [],
    value,
    onChange,
    name = "radio-group",
    required = false,
    requered = false, // Compatibilidade com a prop do modal
    classNames = "mb-1",
    disabled = false,
    inline = true,
    hasError = false,
    hasSuccess = false,
    errorMessage = "",
    error, // Erro externo do modal
    validador
  } = props;

  // Determinar se há erro
  const finalHasError = hasError || !!error;
  const finalErrorMessage = error || errorMessage;
  const isRequired = required || requered;

  const handleChange = (selectedValue) => {
    if (onChange && !disabled) {
      onChange(selectedValue);
      // Chamar validador se fornecido
      if (validador) {
        // Usar setTimeout para garantir que o estado seja atualizado primeiro
        setTimeout(() => {
          validador();
        }, 0);
      }
    }
  };

  const radioName = name || `radio-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`${classNames} input-wrapper radio-wrapper ${finalHasError ? 'has-error' : ''} ${hasSuccess ? 'has-success' : ''}`}>
      <fieldset className="radio-fieldset">
        <legend className="form-label label-input radio-legend">
          {label}
          {isRequired && <span className="text-red required-indicator">*</span>}
        </legend>
        
        <div className={`area-radio-cadastro ${inline ? 'inline' : 'stacked'}`}>
          {values.map((optionValue, index) => {
            const isChecked = value === optionValue;
            const inputId = `${radioName}_${index}`;
            
            return (
              <div 
                key={optionValue} 
                className={`form-check radio-option ${isChecked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
                onClick={() => !disabled && handleChange(optionValue)}
              >
                <input
                  className="form-check-input radio-input"
                  type="radio"
                  id={inputId}
                  name={radioName}
                  value={optionValue}
                  checked={isChecked}
                  onChange={() => handleChange(optionValue)}
                  disabled={disabled}
                  aria-describedby={required ? `${radioName}-required` : undefined}
                />
                <label 
                  htmlFor={inputId} 
                  className={`form-check-label radio-label ${isChecked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
                >
                  {optionValue}
                </label>
              </div>
            );
          })}
        </div>
        
        {isRequired && (
          <div id={`${radioName}-required`} className="sr-only">
            Campo obrigatório
          </div>
        )}
        
        {/* Mensagem de erro */}
        {finalHasError && finalErrorMessage && (
          <div className="erro-formulario" role="alert">
            <i className="fas fa-exclamation-circle me-1"></i>
            {finalErrorMessage}
          </div>
        )}
      </fieldset>
    </div>
  );
};

export default InputRadio;
